import React from 'react';

import { ExportOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { useEnvironnement } from 'hooks/EnvironementStoreContext';
import { useDownloadPdfActionsCamunda } from 'pages/admin-fonctionnel/AdministrationAvancee/ActionCamundaSupressionMasse/useDownloadPdfActionsCamunda';

import { CollapsableContainer } from '../CollapsableContainer';

import '../ActionCommon.less';

const ActionCamundaSuppressionMasse = () => {
  const [env] = useEnvironnement();
  const { download, alertMessage } = useDownloadPdfActionsCamunda();

  return (
    <CollapsableContainer
      title={'Camunda : Suppression des instances en masse'}
      alertMessage={alertMessage}
    >
      <AntdButton type={'primary'} onClick={download}>
        Télécharger la documentation
      </AntdButton>
      <AntdButton
        type={'primary'}
        href={`${env.CAMUNDA_URL}${env.CAMUNDA_MASS_ACTIONS_PATH}`}
        target={'_blank'}
        rel="noopener noreferrer"
      >
        <ExportOutlined /> Actions en masse Camunda
      </AntdButton>
    </CollapsableContainer>
  );
};

export default ActionCamundaSuppressionMasse;
